<div class="warpper-question">
    <div class="columns">
        <div class="columns-title">
            <p translate>questionBoard.edit.group.type-questions</p>
        </div>
        <que-question-item *ngFor="let tq of questionForm.controls.modularQuestions.controls,let i=index"
            [formControl]="tq" (deleteEvent)="deleteModularQuestion(i)" [isSmartQuestion]="isSmartQuestion$()"
            [apiExposureFieldNameFill]="apiExposureFieldNameFill$()"
            [isOnly]="questionForm.controls.modularQuestions.controls.length==1"></que-question-item>
    </div>
    <!-- *ngIf="questionForm.controls.modularQuestions.length<6" -->
    <div  class="addQueation pointer" *ngIf="!isSmartQuestion$()"
        (click)="addModularQuestion()">
        <img src="/assets/images/options/add-question.svg">
        <p translate>questionBoard.edit.table.add-columns</p>
    </div>
    <div class="toggle on pointer" *ngIf="questionForm.controls.toNum.value else toggleOff">
        <que-toggle [toggleState]="questionForm.controls.toNum.value!=null" 
        (toggleEvent)="isSmartQuestion$()?null:toggle($event)"></que-toggle>
        <p translate>questionBoard.edit.group.toggle</p>
        <img class="questionMark" src="/assets/images/question-menu/question-mark.svg">
        <input [formControl]="questionForm.controls.text"
            placeholder="{{'questionBoard.edit.group.placeholder'  | translate}}">
    </div>
</div>
<ng-template #toggleOff>
    <div class="toggle off pointer">
        <div class="toggle-warp" (click)="isSmartQuestion$()?null:toggle(true)">
            <img class="warp-circle" src="/assets/images/options/warp-toggle-of.svg">
            <img class="circleT" src="/assets/images/options/toggle-off.svg">
        </div>
        <p translate>questionBoard.edit.group.toggle</p>
        <img class="questionMark" src="/assets/images/question-menu/question-mark.svg">
    </div>
</ng-template>